import React, { useEffect, useState } from "react";
import "./RCPSList.css";

export default function RCPSList() {

  const user = JSON.parse(localStorage.getItem("user"));
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    const fetchList = async () => {
      try {
        const res = await fetch(
          `https://rcfinder.online/api/rcparticularslist.php?user_id=${user.id}`
        );

        const data = await res.json();
        console.log("RC Particular List Response:", data);

        if (data?.status === "success" && Array.isArray(data.list)) {
          setList(data.list);
        } else {
          setList([]);
        }

      } catch (err) {
        console.error("Fetch Error:", err);
        alert("Server Error");
      }

      setLoading(false);
    };

    fetchList();

  }, []);

  return (
    <div className="rcps-wrapper">

      {/* ================= LOADING ================= */}
      {loading && (
        <div className="rcps-loading">
          <div className="loader"></div>
          <p>Fetching your RC Particulars history...</p>
        </div>
      )}

      <h2 className="rcps-title">RC Particulars History</h2>

      <div className="rcps-box">

        {(!list || list.length === 0) ? (
          <p className="no-data">No records found 😐</p>
        ) : (
          <table className="rcps-table">
            <thead>
              <tr>
                <th>#</th>
                <th>RC Number</th>
                <th>Date</th>
                <th>Download</th>
              </tr>
            </thead>

            <tbody>
              {list.map((r, i) => (
                <tr key={r.id}>
                  <td>{i + 1}</td>
                  <td>{r.rc_number}</td>
                  <td>{r.created_at}</td>

                  <td>
                    {r.pdf_url ? (
                      <a
                        className="rcps-download-btn"
                        href={r.pdf_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        download={`RC_${r.rc_number}.pdf`}
                      >
                        Download
                      </a>
                    ) : (
                      <span className="no-file">PDF Not Available</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>

          </table>
        )}

      </div>
    </div>
  );
}
